import { api_host } from '../constants'
import { apiFetch } from './apiRequestHandler'
// import jwtDecode from 'jwt-decode'

export const getUsers = async () => {
  return await apiFetch(`${api_host}/auth/list`)
}

export const loginApi = (email, password) => {
  return new Promise((resolve, reject) => {
    fetch(`${api_host}/auth/login`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email, password
      })
    })
      .then(resp => resp.json())
      .then(res => {
        if (res.success) {
          resolve(res);
        } else {
          reject(res);
        }
      })
      .catch((err) => {
        reject({ error: "Something went wrong", details: err });
      });
  });
};

export const logoutApi = async () => {
  try {
    await fetch(`${api_host}/auth/logout`, {
      method: 'POST',
      credentials: 'include',
    });
  } catch (err) {
    console.error('Error logging out:', err);
  }
};

export const registerApi = async (email, password) => {
  try {
    const response = await fetch(`${api_host}/auth/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        password,
      }),
    });
    // Check if the response is ok
    if (!response.ok) {
      const responseData = await response.json();
      throw new Error(responseData.error || 'Registration failed');
    }

    // Parse the JSON response if no errors occurred
    return await response.json();
  } catch (error) {
    // Handle fetch or response parsing errors
    console.error('Error in registerApi:', error.message);
    throw error; // Re-throw the error for the caller to handle
  }
};

export const verifyToken = async () => {
  console.log("Verify Token");
  return await apiFetch(`${api_host}/auth/user/me`)
}

export const generateNewApiKey = async () => {
  return await apiFetch(`${api_host}/auth/generate-api-key`)
}

export const updateUser = async (id, fields) => {
  return await apiFetch(`${api_host}/auth/user/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(fields)
  })
}

export const getUser = async () => {
  try {
    console.log("Get User");
    // const token = window.localStorage.getItem('token')
    // const user = token ? jwtDecode(token) : null
    const user = await verifyToken()
    return user
  } catch (e) {
    return null
  }
}

export const requestResetPassword = async (email) => {
  return fetch(`${api_host}/auth/request-reset-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email
    })
  }).then(res => res.json())
}

export const confirmUserApi = async (email, confirmationCode) => {
  try {
    const response = await fetch(`${api_host}/auth/email-confirmation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        confirmationCode,
      }),
    });

    // Check if the response is successful
    if (!response.ok) {
      const errorData = await response.json(); // Extract error details
      throw new Error(errorData.details || errorData.error || 'Failed to confirm user');
    }

    // Parse and return the success response
    return await response.json();
  } catch (error) {
    throw new Error(error.message || 'An unexpected error occurred.');
  }
};

export const resendConfirmationCode = async (email) => {
  try {
    const response = await fetch(`${api_host}/auth/resend-confirmation-code`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
      }),
    });

    // Check if the response is successful
    if (!response.ok) {
      const errorData = await response.json(); // Extract error details
      throw new Error(errorData.error || 'Failed to resend confirmation code');
    }

    // Parse and return the success response
    return await response.json();
  } catch (error) {
    console.error('Error in resendConfirmationCode:', error.message);
    throw error; // Re-throw the error for the caller to handle
  }
};

// Forgot Password
export const forgotPasswordApi = async (email) => {
  try {
    const response = await fetch(`${api_host}/auth/forgot-password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Failed to send password reset code");
    }

    return await response.json();
  } catch (error) {
    console.error("Error in forgotPasswordApi:", error.message);
    throw error;
  }
};

// Confirm Forgot Password
export const confirmForgotPasswordApi = async (email, code, newPassword) => {
  try {
    const response = await fetch(`${api_host}/auth/confirm-forgot-password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        code,
        newPassword,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Failed to confirm new password");
    }

    return await response.json();
  } catch (error) {
    console.error("Error in confirmForgotPasswordApi:", error.message);
    throw error;
  }
};
